import gql from 'graphql-tag';

export default gql`
mutation ($budgetLines: [UpdateBudgetLineInput], $externalMaps: [UpdateExternalMapsInput]!) {
    updateBatchBudgetLine (budgetLines: $budgetLines, externalMaps: $externalMaps) {
        __typename
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BudgetLines/UpdateBatchMutation.js